import React, { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { FormSwitch } from 'components/form/FormSwitch';
import { useDealBuilderContext } from '../../../context/DealBuilderContext';
import { dealBuilderApi } from '../../../api';
import { DealBuilderFormValues } from '../../../types';
import { StepFooterNav } from '../../components/StepFooterNav';
import { FinanceMenuDisabledState } from './FinanceMenuDisabledState';
import { DealBuilderDesking } from './DealBuilderDesking';

export const FinanceMenuStep = () => {
  const { activeEntity, setActiveEntity } = useDealBuilderContext();
  const { control, setValue } = useFormContext<DealBuilderFormValues>();
  const isEnabled = useWatch({ control, name: 'financeMenu.isEnabled' });

  const [updateProposal] = useMutation(dealBuilderApi.updateProposal);

  const handleToggle = useCallback(
    (isEnabled: boolean) => {
      setValue('financeMenu.isEnabled', isEnabled);

      if (activeEntity?.proposal.proposalId && !isEnabled) {
        updateProposal({
          variables: {
            id: activeEntity.proposal.proposalId,
            fieldsObj: {
              settings: null,
            },
          },
          onCompleted: () =>
            setActiveEntity({ ...activeEntity, proposal: { ...activeEntity.proposal, settings: null } }),
        });
      }
    },
    [activeEntity, setValue, updateProposal, setActiveEntity]
  );

  return (
    <CardContainer
      title="Finance & Menu"
      subTitle="Configure finance programs, rates, and build the customer payment menu."
      actionBtn={<FormSwitch label="Enabled" checked={isEnabled} onChange={(_, checked) => handleToggle(checked)} />}
    >
      {isEnabled ? <DealBuilderDesking /> : <FinanceMenuDisabledState onEnable={() => handleToggle(true)} />}
      <StepFooterNav />
    </CardContainer>
  );
};
